import {
  type ComponentProps,
  type ReactNode,
  useLayoutEffect,
  useState,
} from 'react';

interface IImageProps extends ComponentProps<'img'> {
  fallback?: ReactNode;
  errorFallback?: ReactNode;
}

export const AppImage = ({
  src,
  alt = 'image',
  fallback,
  errorFallback,
  ...props
}: IImageProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useLayoutEffect(() => {
    const image = new Image();

    if (src) image.src = src;
    else setIsError(true);

    image.onload = () => {
      setTimeout(() => {
        setIsLoading(false);
      }, 800);
    };

    image.onerror = () => {
      setIsLoading(false);
      setIsError(true);
    };
  }, [src]);

  if (isLoading && fallback) return fallback;

  if (isError && errorFallback) return errorFallback;

  return <img src={src} alt={alt} {...props} />;
};
